export const SET_KEY_TERM_ITEMS = "set_key_term_items";
export const SET_AGREEMENT = "set_agreement";
export const SET_KEY_TERM_GROUP = "set_key_term_group";
export const SET_AGREEMENT_KEY_TERMS = "set_agreement_key_terms";
export const SET_NOTES = "set_notes";